import * as XLSX from 'xlsx';

export const parseSkillsExcel = async (filePath = '/Technology Skills.xlsx') => {
  const response = await fetch(filePath);
  const arrayBuffer = await response.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: 'array' });

  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  const json = XLSX.utils.sheet_to_json(worksheet);

  const skills = json.map(item => item['Example']).filter(Boolean);
  return [...new Set(skills)].sort(); 
};
export const parseSecteursExcel = async (filePath = "/secteurs d'activité.xls") => {
  const response = await fetch(filePath);
  const arrayBuffer = await response.arrayBuffer();
  const workbook = XLSX.read(arrayBuffer, { type: 'array' });

  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];

  const json = XLSX.utils.sheet_to_json(worksheet, {
    range: 3,
    header: ["Code", "Libelle"], 
    defval: "",
  });
  
  const firstItem = json[0] || {};
  const keyForLibelle = Object.keys(firstItem).find(k =>
    k.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().includes("libelle")
  );

  if (!keyForLibelle) {
    return [];
  }

  const secteurs = json.map(item => item["Libelle"]).filter(Boolean);

  return [...new Set(secteurs)].sort();
};
